import React from "react";
import { Route, Switch } from "react-router-dom";
import Videos from "../../../CMS/blog/videos";

export default () => (
  <Switch>
    <Route path="/videos" component={Videos} />
  </Switch>
);
